export const dummySalesData = [
  {
    "date": "2025-07-01",
    "day_of_week": "Tuesday",
    "is_holiday": false,
    "sales_amount": 125000,
    "prediction": 128000,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-02",
    "day_of_week": "Wednesday",
    "is_holiday": false,
    "sales_amount": 138000,
    "prediction": 132000,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-03",
    "day_of_week": "Thursday",
    "is_holiday": false,
    "sales_amount": 142000,
    "prediction": 145000,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-04",
    "day_of_week": "Friday",
    "is_holiday": true,
    "sales_amount": 156000,
    "prediction": 158000,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-05",
    "day_of_week": "Saturday",
    "is_holiday": false,
    "sales_amount": 168000,
    "prediction": 162000,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-06",
    "day_of_week": "Sunday",
    "is_holiday": false,
    "sales_amount": 175000,
    "prediction": 178000,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-07",
    "day_of_week": "Monday",
    "is_holiday": false,
    "sales_amount": 182000,
    "prediction": 185000,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-08",
    "day_of_week": "Tuesday",
    "is_holiday": false,
    "sales_amount": 145000,
    "prediction": 152000,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-09",
    "day_of_week": "Wednesday",
    "is_holiday": false,
    "sales_amount": 158000,
    "prediction": 165000,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-10",
    "day_of_week": "Thursday",
    "is_holiday": false,
    "sales_amount": 162000,
    "prediction": 168000,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-11",
    "day_of_week": "Friday",
    "is_holiday": false,
    "sales_amount": 178000,
    "prediction": 182000,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-12",
    "day_of_week": "Saturday",
    "is_holiday": false,
    "sales_amount": 185000,
    "prediction": 188000,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-13",
    "day_of_week": "Sunday",
    "is_holiday": false,
    "sales_amount": 192000,
    "prediction": 195000,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-14",
    "day_of_week": "Monday",
    "is_holiday": false,
    "sales_amount": 198000,
    "prediction": 202000,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-15",
    "day_of_week": "Tuesday",
    "is_holiday": false,
    "sales_amount": 165000,
    "prediction": 172000,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-16",
    "day_of_week": "Wednesday",
    "is_holiday": false,
    "sales_amount": 172000,
    "prediction": 178000,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-17",
    "day_of_week": "Thursday",
    "is_holiday": false,
    "sales_amount": 188000,
    "prediction": 192000,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-18",
    "day_of_week": "Friday",
    "is_holiday": false,
    "sales_amount": 195000,
    "prediction": 198000,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-19",
    "day_of_week": "Saturday",
    "is_holiday": false,
    "sales_amount": 202000,
    "prediction": 205000,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-20",
    "day_of_week": "Sunday",
    "is_holiday": false,
    "sales_amount": 208000,
    "prediction": 212000,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-21",
    "day_of_week": "Monday",
    "is_holiday": true,
    "sales_amount": 215000,
    "prediction": 218000,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-22",
    "day_of_week": "Tuesday",
    "is_holiday": false,
    "sales_amount": 175000,
    "prediction": 182000,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-23",
    "day_of_week": "Wednesday",
    "is_holiday": false,
    "sales_amount": 182000,
    "prediction": 188000,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-24",
    "day_of_week": "Thursday",
    "is_holiday": false,
    "sales_amount": 198000,
    "prediction": 202000,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-25",
    "day_of_week": "Friday",
    "is_holiday": false,
    "sales_amount": 205000,
    "prediction": 208000,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-26",
    "day_of_week": "Saturday",
    "is_holiday": false,
    "sales_amount": 212000,
    "prediction": 215000,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-27",
    "day_of_week": "Sunday",
    "is_holiday": false,
    "sales_amount": 218000,
    "prediction": 222000,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-28",
    "day_of_week": "Monday",
    "is_holiday": false,
    "sales_amount": 225000,
    "prediction": 228000,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-29",
    "day_of_week": "Tuesday",
    "is_holiday": false,
    "sales_amount": 185000,
    "prediction": 192000,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-30",
    "day_of_week": "Wednesday",
    "is_holiday": false,
    "sales_amount": 192000,
    "prediction": 198000,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-31",
    "day_of_week": "Thursday",
    "is_holiday": false,
    "sales_amount": 198000,
    "prediction": 205000,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  }
]; 